import { render, staticRenderFns } from "./partnership_form_preview.vue?vue&type=template&id=1fe900a4&"
import script from "./partnership_form_preview.vue?vue&type=script&lang=js&"
export * from "./partnership_form_preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports